<div class="analytics-dashboard-container">
  <!-- Loading Skeleton -->
  <div *ngIf="isLoading" class="skeleton-container">
    <div class="skeleton skeleton-title"></div>
    <div class="skeleton skeleton-chart"></div>
    <div class="skeleton-row">
      <div class="skeleton skeleton-card"></div>
      <div class="skeleton skeleton-card"></div>
      <div class="skeleton skeleton-card"></div>
    </div>
  </div>

  <!-- Error: Access Denied (403) -->
  <div *ngIf="!isLoading && errorType === 'access_denied'" class="error-container">
    <div class="error-icon"><i class="bi bi-lock-fill"></i></div>
    <h5>Access Denied</h5>
    <p class="text-muted">{{ errorMessage }}</p>
    <p class="text-muted small">Contact your administrator to request access to this dashboard.</p>
  </div>

  <!-- Error: Service Unavailable (503) -->
  <div *ngIf="!isLoading && errorType === 'unavailable'" class="error-container">
    <div class="error-icon text-warning"><i class="bi bi-cloud-slash-fill"></i></div>
    <h5>Analytics Unavailable</h5>
    <p class="text-muted">{{ errorMessage }}</p>
    <button class="btn btn-primary btn-sm mt-2" (click)="reload()">
      <i class="bi bi-arrow-clockwise me-1"></i> Retry
    </button>
  </div>

  <!-- Error: Stale Dashboard -->
  <div *ngIf="!isLoading && errorType === 'stale'" class="error-container">
    <div class="error-icon text-warning"><i class="bi bi-exclamation-triangle-fill"></i></div>
    <h5>Dashboard Unavailable</h5>
    <p class="text-muted">{{ errorMessage }}</p>
    <button class="btn btn-outline-secondary btn-sm mt-2" (click)="navigateToSettings()">
      <i class="bi bi-gear me-1"></i> Go to Settings
    </button>
  </div>

  <!-- Error: Integration Disconnected -->
  <div *ngIf="!isLoading && errorType === 'disconnected'" class="error-container">
    <div class="error-icon text-danger"><i class="bi bi-plug-fill"></i></div>
    <h5>Analytics Integration Disconnected</h5>
    <p class="text-muted">
      Analytics dashboards are not available because the integration is disconnected.
    </p>
    <button class="btn btn-outline-secondary btn-sm mt-2" (click)="navigateToSettings()">
      <i class="bi bi-arrow-clockwise me-1"></i> Reconnect Integration
    </button>
  </div>

  <!-- Error: Generic -->
  <div *ngIf="!isLoading && errorType === 'generic'" class="error-container">
    <div class="error-icon"><i class="bi bi-exclamation-circle-fill"></i></div>
    <h5>Unable to Load Dashboard</h5>
    <p class="text-muted">{{ errorMessage }}</p>
    <button class="btn btn-primary btn-sm mt-2" (click)="reload()">
      <i class="bi bi-arrow-clockwise me-1"></i> Retry
    </button>
  </div>

  <!-- Dashboard Embed -->
  <div *ngIf="!isLoading && !hasError && embedConfig" class="embed-wrapper">
    <!-- Iframe loading overlay â€” shown until the iframe fires load event -->
    <div *ngIf="!iframeLoaded" class="iframe-loading">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted small">Loading dashboardâ€¦</p>
    </div>
    <iframe
      [src]="safeEmbedUrl"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      allow="fullscreen"
      class="dashboard-iframe"
      [class.iframe-hidden]="!iframeLoaded"
      title="Analytics Dashboard"
      (load)="onIframeLoad()"
    ></iframe>
  </div>
</div>
